import {
    Alert,
    CssBaseline,
    Link,
    Stack,
    SvgIcon,
    ThemeProvider
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { muiTheme } from "../welcomeSetup/theme/theme";

const BankLinkNotificationContainer = ({ customer, rounded = false, p = 0 }) => {
  const navigate = useNavigate();

  const isDemo = customer?.is_demo === true;
  const hasBankLinked = Array.isArray(customer?.completed_setup_steps)
    && customer.completed_setup_steps.includes("bank_linked");
  const is_consolidated = customer?.customer_type === "group"

  if (isDemo || hasBankLinked || is_consolidated) {
    return null;
  }

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <Stack padding={p} width="100%">
        <Alert
          icon={
           <SvgIcon>
            <image href="/info.svg" width="20" height="20" />
          </SvgIcon>
          }
          severity="info"
          sx={{
            backgroundColor: "#BEE3F8",
            color: "#2B6CB0",
            borderRadius: rounded ? "10px" : "0px",
            width: "100%",
            paddingY: "12px",
            "& .MuiAlert-message": {
              display: "block",
              width: "100%",
              lineHeight: "1.3",
            },
          }}
        >
          <span style={{ fontWeight: "bold", fontSize: "16px" }}>
            Connect your bank to get started!
          </span>{" "}
          <span style={{ fontSize: "16px" }}>
            Please{" "}
            <Link
              component="button"
              onClick={() => navigate("/settings/bank-management")}
              sx={{
                textDecoration: "underline",
                cursor: "pointer",
                color: "#2B6CB0",
                padding: 0,
                fontSize: "16px",
              }}
            >
              click here
            </Link>{" "}
            to securely sync your transactions and see your real performance.
          </span>
        </Alert>
      </Stack>
    </ThemeProvider>
  );
};

export default BankLinkNotificationContainer;
